export { default as SquareCloseIcon } from './SquareCloseIcon'
